import { z } from 'zod';

export const GamificationStatsSchema = z.object({
  enabled: z.boolean(), // Projekt-Toggle UND User-Opt-out zusammengefasst
  executed_today: z.number().int(),
  streak_days: z.number().int(),
  team_progress_pct: z.number(), // Phasen-Fortschrittsbalken (gemeinsames Ziel, GAM-2)
  coverage_pct: z.number(),
  next_coverage_milestone: z.number().int().nullable(), // 25/50/75/100 oder null wenn 100 erreicht
  problems_caught: z.number().int(), // gefundene Fehler, positiv umgedeutet (GAM-2)
});
export type GamificationStats = z.infer<typeof GamificationStatsSchema>;
